import React, { Component } from "react";
import IconButton from "material-ui/IconButton";
import RefreshIndicator from "material-ui/RefreshIndicator";
import ActionMenu from "material-ui/svg-icons/navigation/menu";
import ActionClose from "material-ui/svg-icons/navigation/close";
import { connect } from "react-redux";

import Nav from "./Nav";
import msem from "../msem.svg";
import "./Layout.css";
import { menuOpen, menuClose } from "./actions";

class Layout extends Component {
  openDrawer = () => {
    this.props.menuOpen();
  };

  closeDrawer = () => {
    this.props.menuClose();
  };

  loader() {
    if (this.props.waiting) {
      return (
        <div className="loaderContainer">
          <RefreshIndicator size={24} left={0} top={0} status="loading" />
        </div>
      );
    }
  }

  render() {
    const classes = this.props.menuOpened ? "shell opened" : "shell";

    return (
      <div className={classes}>
        <nav className="drawer">
          <header className="toolbar">
            <IconButton onClick={this.closeDrawer}>
              <ActionClose />
            </IconButton>
            <img src={msem} alt="MSEM" />
          </header>
          <Nav to={this.props.to} />
        </nav>
        <div className="overlay" onClick={this.closeDrawer} />
        <section className="content">
          <header className="toolbar">
            <IconButton onClick={this.openDrawer}>
              <ActionMenu />
            </IconButton>
            <span className="title">{this.props.title}</span>
            {this.loader()}
          </header>
          <main>{this.props.children}</main>
        </section>
      </div>
    );
  }
}

/***************** Container part */

const getTitle = (items, to) =>
  items.reduce(
    (title, item) =>
      !title && item.children
        ? getTitle(item.children, to)
        : !title && to.indexOf(item.to) === 0
        ? item.title
        : title,
    undefined
  );

const mapStateToProps = state => ({
  menuOpened: state.app.menuOpened,
  waiting: state.app.waiting,
  title: getTitle(state.app.navigation, state.router.location.pathname)
});

const mapDispatchToProps = (dispatch, state) => ({
  menuOpen: () => {
    dispatch(menuOpen());
  },

  menuClose: () => {
    dispatch(menuClose());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Layout);



// WEBPACK FOOTER //
// ./src/app/Layout.js